import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Phone } from 'lucide-react'

import { BUSINESS } from '@/content/business'

const MobileCallBar: FC = (): ReactNode => {
    return (
        <nav
            aria-label='Quick contact'
            className='fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-3 border-t border-white/15 bg-navy-deep/97 px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 md:hidden'
        >
            <a
                href={BUSINESS.phoneHref}
                className='inline-flex min-h-14 items-center justify-center gap-2 rounded-xl bg-primary text-lg font-bold text-white'
            >
                <Phone className='size-5' aria-hidden='true' />
                Call now
            </a>

            <Link
                href='/contact/'
                className='inline-flex min-h-14 items-center justify-center rounded-xl bg-white text-lg font-bold text-navy'
            >
                Free estimate
            </Link>
        </nav>
    )
}

export default MobileCallBar
